/* eslint-disable security/detect-non-literal-regexp */
/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useContext,useState,useRef ,useEffect} from 'react';
import GlobalContext from '../../Context/GloablContext';
import { Link, useLocation} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AnimatedModel from '../../Animation/AnimatedModel';
import { AnimatePresence } from 'framer-motion';
import ConfirmationPrompt from '../../ConfirmationPrompt';
import {handleClear, handleSidebarAnimation} from '../../../redux/commonSlice'
import {motion} from 'framer-motion'
import { useNavigate } from 'react-router-dom';
import { logout } from '../../../pages/auth/authSlice';
import { usersList } from '../../../features/apiSlice';
import { userService } from '../../../services/user.services';
import { resetDeviceSearch } from '../../../redux/deviceSearchSlice';
import { resetDeviceTemplateSearch } from '../../../redux/deviceTemplateSearchSlice';
import { resetProviderSearch } from '../../../redux/providerSearchSlice';
import { resetObserverSearch } from '../../../redux/observerSearchSlice';
import { resetPatientSearch } from '../../../redux/patientSearchSlice';
import { useAdminOrCorporateSearch } from '../../Context/adminCorporateSearch';
import { resetOrganizationSearch } from '../../../redux/organizationSearchSlice';
import { resetDeviceAlertSearch } from '../../../redux/deviceAlertReportSearchSlice';
import { resetAccessLogSearch } from '../../../redux/accessLogSearchSlice';
import { resetDeviceAlertDashboardSearch } from '../../../redux/deviceAlertDashboardSlice';
import { resetDashboardSearch } from '../../../redux/dashboardSearchSlice';
import { resetWellnessReportSearch } from '../../../redux/wellnessReportSearchSlice';
import { clearAuthSession, broadcastLogout, getAuthItem } from '../../../CommonMethods/authSession';
import { clearStoredIPAddress } from '../../../services/ipAddress.service';

const SideNavBar = ({role}) => {
    const location=useLocation()
    const {state}=useLocation()
    const [logOutOpen, setLogOutOpen] = useState(false);
    const [logoutLoading, setLogoutLoading] = useState(false)
    const navigate=useNavigate()
    const restrict = useSelector(state=>state?.systemConfigData?.restrict)
    const auth=useSelector(state=>state?.auth)
    const isAnimating=useSelector(state=>state?.commonData?.isAnimating)
    const userType = getAuthItem('user_type')
    const {resetAdvancedAdminCorSearch } = useAdminOrCorporateSearch();


  
    let usrType=""
    if(userType==="super-admin"){
        usrType="Super Admin"
    }
    else if(userType==="admin-user"){
        usrType="ADMIN"
    }
    else{
        usrType="CORPORATE"
    }

    // Sidebar options based on user type
    const sidebarObjs = {
        "super-admin": [
            'Manage Admin / Corporate Users',
            'Manage Organizations',
            'Manage Monitor Users',
            'Manage Patients',
            'Manage Monitoring Conditions Templates',
            'Manage Observers',
            'Manage Providers',
            'Manage Devices',
            'Manage Device Profile',
            'Access Logs',
            'Import',
            'Activity History',
        ],
        "admin-user": [
            'Manage Admin / Corporate Users',
            'Manage Organizations',
            'Manage Monitor Users',
            'Manage Patients',
            'Manage Monitoring Conditions Templates',
            'Manage Observers',
            'Manage Providers',
            'Manage Devices',
            'Manage Device Profile',
            'Access Logs',
            'Import',
            'Activity History',
            'Upload File'
        ],
        "corporate-user": [
            'Dashboard',
            'Manage Admin / Corporate Users',
            'Manage Patients',
            'Manage Monitoring Conditions Templates',
            'Manage Observers',
            'Manage Providers',
            'Manage Devices',
            'Manage Device Profile',
            'Import',
            'Upload File'
        ]
    };

    const linksTo = {
        "super-admin": [
            '/manage-admin-corporate',
            '/manage-organizations',
            '/manage-monitor-user',
            '/manage-patients',
            '/manage-monitoring-condition-templates',
            '/manage-observer',
            '/manage-provider',
            '/manage-devices',
            '/manage-device-templates',
            '/manage-access-logs',
            '/manage-import',
            '/manage-activity-history',
            
        ],
        "admin-user": [
            '/manage-admin-corporate',
            '/manage-organizations',
            '/manage-monitor-user',
            '/manage-patients',
            '/manage-monitoring-condition-templates',
            '/manage-observer',
            '/manage-provider',
            '/manage-devices',
            '/manage-device-templates',
            '/manage-access-logs',
            '/manage-import',
            '/manage-activity-history',
            '/upload-file'
        ],
        "corporate-user": [
            '/dashboard',
            '/manage-admin-corporate',
            '/manage-patients',
            '/manage-monitoring-condition-templates',
            '/manage-observer',
            '/manage-provider',
            '/manage-devices',
            '/manage-device-templates',
            '/manage-import',
            '/upload-file'
        ]
    };

    const imagesTo = {
        "super-admin": [
            '/images/manage_admin_default.svg',
            '/images/manage_organization_default.svg',
            '/images/manage_monitor_default.svg',
            '/images/manage_patients_default.svg',
            '/images/clipboard default.svg',
            '/images/manage_observer_default.svg',
            '/images/manage_provider_default.svg',
            '/images/manage_device_default.svg',
            '/images/manage_device_profile_default.svg',
            '/images/access_log_default.svg',
            '/images/importicon.svg',
            '/images/activity_history_default.svg',
        ],
        "admin-user": [
            '/images/manage_admin_default.svg',
            '/images/manage_organization_default.svg',
            '/images/manage_monitor_default.svg',
            '/images/manage_patients_default.svg',
            '/images/clipboard default.svg',
            '/images/manage_observer_default.svg',
            '/images/manage_provider_default.svg',
            '/images/manage_device_default.svg',
            '/images/manage_device_profile_default.svg',
            '/images/access_log_default.svg',
            '/images/importicon.svg',
            '/images/activity_history_default.svg',
            '/images/uploadFile_default.svg'
        ],
        "corporate-user": [
            '/images/manage_organization_default.svg',
            '/images/manage_admin_default.svg',
            '/images/manage_patients_default.svg',
            '/images/clipboard default.svg',
            '/images/manage_observer_default.svg',
            '/images/manage_provider_default.svg',
            '/images/manage_device_default.svg',
            '/images/manage_device_profile_default.svg',
            '/images/importicon.svg',
            '/images/uploadFile_default.svg'
        ]
    };
    
    // Get the appropriate images for the current user
    const images = imagesTo[userType];
    

    // Get the appropriate options for the current user
    const sidebar1Objs = sidebarObjs[userType];
    const linksTo1 = linksTo[userType];

    const firstName=JSON.parse(localStorage.getItem('user-info')===null?sessionStorage.getItem('user-info'):localStorage.getItem('user-info'))?.first_name
    const lastName=JSON.parse(localStorage.getItem('user-info')===null?sessionStorage.getItem('user-info'):localStorage.getItem('user-info'))?.middle_name
    /* Using the useContext hook to access the state variables `isSideNavBar` and `setIsSideNavBar`
    from the `GlobalContext` context. These variables are likely used to control the visibility and
    behavior of a side navigation bar in the UI. */
    const ulRef = useRef(null);
    const sidebar2Objs = userType === 'corporate-user' ? [] : ['System Configuration']
    const linksTO2 = userType === 'corporate-user' ? [] : ["/system-configuration"]
    const images2 = userType === 'corporate-user' ? [] : ["/images/Settings.svg"]
    const {isSideBar, setIsSideBar,show, setshow,setToastmessage,initialRoutePath,setInitialRoutePath,isOpen,setIsOpen,isAdvancedSearchOpen,setIsAdvancedSearchOpen,editSocket} = useContext(GlobalContext);
    /**
     * This function toggles the state of a side navigation bar.
     */
    const dispatch=useDispatch()
    const browserIdValue = localStorage.getItem('arcm_trust_browser_token');
    const handleLogout=async ()=>{
        setLogoutLoading(true)
        setIsAdvancedSearchOpen(false),
        dispatch(resetDeviceTemplateSearch()),
        dispatch(resetDeviceSearch()),
        dispatch(resetProviderSearch()),
        dispatch(resetObserverSearch()),
        dispatch(resetPatientSearch()),
        dispatch(resetOrganizationSearch()),
        dispatch(resetDeviceAlertSearch()),
        dispatch(resetAccessLogSearch())
        dispatch(resetDeviceAlertDashboardSearch()),
        dispatch(resetWellnessReportSearch())
        dispatch(resetDashboardSearch())
        resetAdvancedAdminCorSearch()
        dispatch(handleClear())
        await userService.logout()

        // Broadcast logout to other tabs BEFORE clearing auth
        // This ensures other tabs receive the event before we clear localStorage
        broadcastLogout('manual');

        // Clear auth FIRST so ws.onclose() won't auto-reconnect (it checks IdToken)
        clearAuthSession();
        clearStoredIPAddress();

        // Close WebSocket AFTER clearing auth — onclose fires but IdToken is gone
        // so auto-reconnect logic is skipped
        if (editSocket && (editSocket.readyState === 0 || editSocket.readyState === 1)) {
            try {
                if (editSocket.readyState === 1) {
                    editSocket.send(JSON.stringify({
                        action: 'stopEditing',
                        target: ''
                    }));
                }
                editSocket.close();
            } catch (error) {
                console.error('Error closing WebSocket during logout:', error);
            }
        }

        dispatch(logout());
        localStorage.setItem('arcm_trust_browser_token', browserIdValue);
        dispatch(handleSidebarAnimation(true))
        setToastmessage('Logout successful')
        localStorage.setItem('LogoutfromAllTabs','true')
        navigate('/')
        dispatch(usersList.util.resetApiState())
        setLogoutLoading(false)

    }
    const ref = useRef();

 
    
    const handleClickSideNavBar = () => {
        setIsSideBar(!isSideBar);
    }

    useEffect(() => {
        if(location.pathname.includes('reports')||location.pathname.includes('manage-activity-history')||location.pathname.includes('manage-import')||location.pathname.includes('upload-file')){
            if (ulRef.current) {
                ulRef.current.scrollTop = ulRef.current.scrollHeight;
            }
        }
       
    }, []);

    useEffect(()=>{
        restrict?setIsSideBar(true):setIsSideBar(false)
    },[restrict])
   
    const handleRedirection = (e) => {
        e.preventDefault(); // Prevent default behavior of the Link
        dispatch(handleSidebarAnimation(false));
    
        // Check the role from storage
        const userRole = getAuthItem('user_type');
        
        if (userRole === 'corporate-user' || userRole==='admin-user') {
            navigate('/profile');
        }
        
    };

    const handleOnClickSidenav = () =>{
        
        dispatch(handleSidebarAnimation(false))
        setIsAdvancedSearchOpen(false),
        dispatch(resetDeviceTemplateSearch()),
        dispatch(resetDeviceSearch()),
        dispatch(resetProviderSearch()),
        dispatch(resetObserverSearch()),
        dispatch(resetPatientSearch()),
        dispatch(resetOrganizationSearch()),
        dispatch(resetDeviceAlertSearch()),
        dispatch(resetAccessLogSearch()),
        dispatch(resetDeviceAlertDashboardSearch()),
        resetAdvancedAdminCorSearch()
        dispatch(usersList.util.resetApiState())
        dispatch(resetWellnessReportSearch())
        
    }
    
    return (
        <AnimatePresence>
            {!isSideBar?
                <div id="sidenav" className='flex top-0 left-0 min-w-[256px] w-[256px] shadow-s2 h-screen rounded-tr-[12px] rounded-br-[12px] border-r border-[#0000001A] z-[99] bg-[#fff] opened_sidebar'>
                    <div className='w-full p-4'>
                        {isAnimating?<motion.div 
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{duration:0.5}}
                        >
                            < div className='flex items-center pb-4 relative cursor-pointer'>
                                <Link onClick={handleRedirection} >
                                    <motion.div
                                        initial={{ opacity: 0, scale: 0.6 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{
                                            duration: 0.3,
                                            delay: 0.5,
                                            ease: [0, 0.71, 0.2, 1.01],
                                        }}>
                                        <div title="profile" id="my-profile" className='w-11 h-11 bg-[#E7CBD2] rounded-[50%] enlarge-image transform hover:scale-120 flex justify-center items-center'>
                                            <p className='text-[#972E4C] font-semibold text-lg uppercase'>{lastName?.charAt(0)}{firstName?.charAt(0)}</p>
                                        </div>
                                    </motion.div>
                                </Link>
                                
                                <div className='pl-3'>
                                    <p className='text-f1 font-medium text-[#757575]'>{usrType}</p>

                                    <p className='text-sm font-medium text-black'>{`${lastName} ${firstName}`}</p>
                                </div>
                                {/* onMouseEnter={()=>setIsSideBar(false)} onMouseLeave={()=>setIsSideBar(true)} */}
                                <button id="menu" className='p-1.5 border border-[#F6F6F6] rounded-lg shadow-s2 pl-1 absolute top-2 right-[-29px] bg-white' disabled={restrict} onClick={handleClickSideNavBar}>
                                    <img loading='lazy' decoding='async' src="/images/menu_slider.svg" alt="menu-icon" className='rotate-180'/>
                                </button>
                            </div>
                        </motion.div>:<>
                            <div className='flex items-center pb-4 relative'>
                                <Link onClick={handleRedirection} >
                                    <div title="profile" id="my-profile" className='w-11 h-11 bg-[#E7CBD2] rounded-[50%] enlarge-image transform hover:scale-120 flex justify-center items-center'>
                                        <p className='text-[#972E4C] font-semibold text-lg uppercase'>{lastName?.charAt(0)}{firstName?.charAt(0)}</p>
                                    </div>
                                </Link>
                                <div className='pl-3'>
                                    <p className='text-f1 font-medium text-[#757575]'>{usrType}</p>
                                    <p className='text-sm font-medium text-black'>{`${lastName} ${firstName}`}</p>
                                </div>
                                {/* onMouseEnter={()=>setIsSideBar(false)} onMouseLeave={()=>setIsSideBar(true)} */}
                                <button id="menu" className='p-1.5 border border-[#F6F6F6] rounded-lg shadow-s2 pl-1 absolute top-2 right-[-29px] bg-white' disabled={restrict} onClick={handleClickSideNavBar}>
                                    <img loading='lazy' decoding='async' src="/images/menu_slider.svg" alt="menu-icon" className='rotate-180'/>
                                </button>
                            </div>

                        </>}
                        <div className='h-[2px] bg-[#C5C9DA] rounded-sm mb-4'></div>
                        <ul ref={ulRef} className='h-customh17 overflow-auto scrollbar_purple'>
                            {sidebar1Objs?.map((element,index)=>(
                                isAnimating?<motion.div 
                                    animate={{ x: 0 }}
                                    initial={{ x: -10 }}
                                    transition={{duration:0.5}}
                                    key={index}
                                    className={`text-f1 font-medium mb-2`}>
                                    <li >
                                        {location.pathname!==linksTo1[index]||location.hash==="#report"?<Link  to={linksTo1[index]} onClick={()=>{dispatch(handleSidebarAnimation(false))}} className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg ${location.pathname.includes(linksTo1[index])&&!logOutOpen&&!(location?.hash==="#report")?'bg-[#972E4C] bg-opacity-50':""}`}>
                                            
                                            <motion.img  
                                                initial={{ opacity: 0, scale: 0.6 }}
                                                animate={{ opacity: 1, scale: 1 }}
                                                transition={{
                                                    duration: 0.3,
                                                    delay: 0.5,
                                                    ease: [0, 0.71, 0.2, 1.01],
                                                }}
                                                
                                                loading="lazy" decoding="async" src={images[index]} style={location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}}  alt="icon" />
                                            <p className={`pl-3 text-xs font-semibold ${location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?'text-[#972E4C] ':'text-[#52555D]'}`}>{element}</p>
                                        </Link>:<div  className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg cursor-pointer ${location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?'bg-[#972E4C] bg-opacity-50':""}`}>
                                            
                                            <motion.img  
                                                initial={{ opacity: 0, scale: 0.6 }}
                                                animate={{ opacity: 1, scale: 1 }}
                                                transition={{
                                                    duration: 0.3,
                                                    delay: 0.5,
                                                    ease: [0, 0.71, 0.2, 1.01],
                                                }}
                                                
                                                loading="lazy" decoding="async" src={images[index]} style={location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}}  alt="icon" />
                                            <p className={`pl-3 text-xs font-semibold ${location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?'text-[#972E4C] ':'text-[#52555D]'}`}>{element}</p>
                                        </div>}
                                    </li>
                                </motion.div>: <li key={index+"1"}>
                                    {location.pathname!==linksTo1[index] || location.hash==="#report" ?<Link onClick={()=>{handleOnClickSidenav()}} key={index+"5"} to={linksTo1[index]} className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg ${location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?'bg-[#972E4C] bg-opacity-50':""}`}> 
                                        <img
                                            loading="lazy" decoding="async" style={location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}} src={images[index]}  alt="icon"  />
                                        <p className={`pl-3 text-xs font-semibold ${location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?'text-[#972E4C] ':'text-[#52555D]'}`}>{element}</p>
                                    </Link>:<div  className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg cursor-pointer ${location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?'bg-[#972E4C] bg-opacity-50':""}`}> 
                                        <img
                                            loading="lazy" decoding="async" style={location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}} src={images[index]}  alt="icon"  />
                                        <p className={`pl-3 text-xs font-semibold ${location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?'text-[#972E4C] ':'text-[#52555D]'}`}>{element}</p>
                                    </div>}
                                </li>
                            ))}
                        
                            {isAnimating?<motion.div 
                                animate={{ x: 0 }}
                                initial={{ x: -10 }}
                                transition={{duration:0.5}}
                                exit={{y:-10}}
                                className={`text-f1 font-medium mb-2`}>
                                <li>
                                    <div className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg cursor-pointer ${(location.pathname.includes('reports')||location.hash==="#report")&&!logOutOpen?'bg-[#972E4C] bg-opacity-50':""}`}>
                                        <Link to={location.pathname+location.search+'#report'} onClick={()=>{setIsOpen(!isOpen)}} className='flex justify-between items-center w-full'>
                                            <div className='flex items-center'>
                                                <motion.img  
                                                    initial={{ opacity: 0, scale: 0.6 }}
                                                    animate={{ opacity: 1, scale: 1 }}
                                                    transition={{
                                                        duration: 0.3,
                                                        delay: 0.5,
                                                        ease: [0, 0.71, 0.2, 1.01],
                                                    }}
                                                    loading="lazy" decoding="async" src={"/images/Reports_default.svg"}  style={(location.pathname.includes('reports')||location.hash==="#report")&&!logOutOpen?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}} alt="icon" />
                                                {/* <img src="images/Reports_default.svg" alt="icon" /> */}
                                                <p className={`pl-3 text-xs font-semibold ${(location.pathname.includes('reports')||location.hash==="#report")&&!logOutOpen?'text-[#972E4C] ':'text-[#52555D]'}`} >Reports</p>
                                            </div>
                                            <span>
                                                <img loading="lazy" decoding="async" className={`${(isOpen)?"transform rotate-180" : ""}`} style={(location.pathname.includes('reports')||location.hash==="#report")&&!logOutOpen?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}} src="/images/dropdown_icon.svg" alt="icon" />
                                            </span>
                                        </Link>
                                    </div>
                                    {(isOpen)&&<motion.div 
                                        animate={{ x: 0,y:0 }}
                                        initial={{ y: -10 }}
                                        transition={{duration:0.2}}
                                        
                                        className={`text-f1 font-medium mb-2`}><div className='pl-5'>
                                        
                                            <Link key={'alert-report'} to={'/reports/alert-report'} onClick={()=>{ dispatch(handleSidebarAnimation(false)),dispatch(resetDeviceAlertSearch())}} className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg `}>
                                                <p className={`pl-3 text-xs font-semibold ${location.pathname.includes('reports/alert-report')&&!logOutOpen?'text-[#972E4C] ':'text-[#52555D]'}`}>Alert Reports</p></Link>
                                            <Link key={'wellness-report'} onClick={()=>{ dispatch(handleSidebarAnimation(false)),dispatch(resetDeviceAlertSearch())}} to={'/reports/wellness-report'} className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg`}>
                                                <p className={`pl-3 text-xs font-semibold ${location.pathname.includes('reports/wellness-report')&&!logOutOpen?'text-[#972E4C] ':'text-[#52555D]'}`}>Wellness Reports</p></Link>
                                        </div></motion.div>}
                                </li>
                            </motion.div>:<>
                                <li>
                                    <div className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg cursor-pointer ${(location.pathname.includes('reports')||location.hash==="#report")&&!logOutOpen?'bg-[#972E4C] bg-opacity-50':""}`}>
                                        <Link  to={location.pathname+location.search+'#report'} onClick={()=>{setIsOpen(!isOpen)}} className={`flex justify-between items-center w-full`}>
                                            <div className='flex items-center'>
                                                <img
                                                    loading="lazy" decoding="async" src={"/images/Reports_default.svg"} style={(location.pathname.includes('reports')||location.hash==="#report")&&!logOutOpen?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}}  alt="icon" />
                                                {/* <img src="images/Reports_default.svg" alt="icon" /> */}
                                                <p className={`pl-3 text-xs font-semibold ${(location.pathname.includes('reports')||location.hash==="#report")&&!logOutOpen?'text-[#972E4C] ':'text-[#52555D]'}`}>Reports</p>
                                            </div>
                                            <span>
                                                <img src="/images/dropdown_icon.svg"  alt="icon" className={`${(isOpen)?"transform rotate-180" : ""}`} style={((isOpen)||location.pathname.includes('reports'))&&!logOutOpen?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}} />
                                            </span>
                                        </Link>
                                    </div>
                                    {(isOpen)&&<motion.div 
                                        animate={location.hash==='#report'&&{ x: 0,y:0 }}
                                        initial={location.hash==='#report'&&{ y: -10 }}
                                        transition={location.hash==='#report'&&{duration:0.2}}
                                        exit={location.hash==='#report'&&{y:10}}
                                        className={`text-f1 font-medium mb-2`}><div className='pl-5'>
                                            <Link onClick={()=>{ dispatch(handleSidebarAnimation(false)),dispatch(resetDeviceAlertSearch(),handleOnClickSidenav()
                                            );
                                            }} key={'alert-report'} to={'/reports/alert-report'} className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg`}>
                                                <p className={`pl-3 text-xs font-semibold ${location.pathname.includes('/reports/alert-report')&&!logOutOpen?'text-[#972E4C] ':'text-[#52555D]'}`}>Alert Reports</p></Link>
                                            <Link onClick={()=>{ dispatch(handleSidebarAnimation(false)),dispatch(resetDeviceAlertSearch(),handleOnClickSidenav())}} key={'wellness-report'} to={'/reports/wellness-report'} className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg`}><p className={`pl-3 text-xs font-semibold ${location.pathname.includes('/reports/wellness-report')&&!logOutOpen?'text-[#972E4C] ':'text-[#52555D]'}`}>Wellness Reports</p></Link>
                                        </div></motion.div>}
                                </li>
                            </>}
                        </ul>
                        {userType !== 'corporate-user' && <div className='h-[2px] bg-[#C5C9DA] rounded-sm mb-4'></div>}
                        <ul className={userType === 'corporate-user' ? 'mt-6' : ''}>
                            {sidebar2Objs?.map((element,index)=>(
                                isAnimating?<motion.div 
                                    animate={{ x: 0 }}
                                    initial={{ x: -10 }}
                                    transition={{duration:0.5}}
                                    key={index}
                                    className={`text-f1 font-medium mb-2`} >
                                    <li >
                                        <Link to={linksTO2[index]}  onClick={()=>{ dispatch(handleSidebarAnimation(false)),dispatch(resetDeviceAlertSearch())}} className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg ${location.pathname.includes(linksTO2[index])&&!logOutOpen&&location?.hash===""?'bg-[#972E4C] bg-opacity-50':""}`}>
                                            <motion.img  
                                                initial={{ opacity: 0, scale: 0.6 }}
                                                animate={{ opacity: 1, scale: 1 }}
                                                transition={{
                                                    duration: 0.3,
                                                    delay: 0.5,
                                                    ease: [0, 0.71, 0.2, 1.01],
                                                }}
                                                loading="lazy" key={index+"4"} decoding="async" src={images2[index]} style={location.pathname.includes(linksTO2[index])&&!logOutOpen&&location?.hash===""?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}} alt="icon" />
                                            <p className={`pl-3 text-xs font-semibold ${location.pathname.includes(linksTO2[index])&&!logOutOpen&&location?.hash===""?'text-[#972E4C] ':'text-[#52555D]'}`}>{element}</p>
                                        </Link>
                                    </li>
                                </motion.div>: <li key={index+"1"}>
                                    <Link  to={linksTO2[index]} onClick={()=>{ dispatch(handleSidebarAnimation(false)), dispatch(resetDeviceAlertSearch())}} className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg ${location.pathname.includes(linksTO2[index])&&!logOutOpen&&location?.hash===""?'bg-[#972E4C] bg-opacity-50':""}`}>
                                        <img
                                            loading="lazy" decoding="async" src={images2[index]}  alt="icon" style={location.pathname.includes(linksTO2[index])&&!logOutOpen&&location?.hash===""?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}}/>
                                        <p className={`pl-3 text-xs font-semibold ${location.pathname.includes(linksTO2[index])&&!logOutOpen&&location?.hash===""?'text-[#972E4C] ':'text-[#52555D]'}`} >{element}</p>
                                    </Link>
                                </li>

                            ))}
                        </ul>
                        {userType === 'corporate-user' && <div className='h-[2px] bg-[#C5C9DA] rounded-sm mb-4'></div>}
                        <ul className=''>
                            <li>
                                {isAnimating?<motion.div 
                                    animate={{ x: 0 }}
                                    initial={{ x: -10 }}
                                    transition={{duration:0.5}}
                                    className={`text-f1 font-medium mb-2`} key="logout">
                                    <button id="logout" className={`px-3 py-2.5 w-full flex items-center rounded-lg ${logOutOpen&&location?.hash===""?'bg-[#972E4C] bg-opacity-50 ':''}`}  onClick={()=>{setLogOutOpen(true)}}>
                                        <motion.img  
                                            initial={{ opacity: 0, scale: 0.6 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            transition={{
                                                duration: 0.3,
                                                delay: 0.5,
                                                ease: [0, 0.71, 0.2, 1.01],
                                            }}
                                            loading="lazy" decoding="async" src={"/images/Log-out.svg"}  alt="icon"  style={logOutOpen&&location?.hash===""?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}}/>
                                        <p className={`pl-3 text-xs font-semibold ${logOutOpen&&location?.hash===""?'text-[#972E4C] ':'text-[#52555D]'} `} >Logout</p>
                                    </button>
                                </motion.div>:<>
                                    <button id="logout" className={`px-3 py-2.5 w-full flex items-center rounded-lg ${logOutOpen?'bg-[#972E4C] bg-opacity-50':''}`} onClick={()=>{setLogOutOpen(true)}}>
                                        <img
                                            loading="lazy" decoding="async" src={"/images/Log-out.svg"} style={logOutOpen&&location?.hash===""?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}} alt="icon" />
                                        <p className={`pl-3 text-xs font-semibold ${logOutOpen&&location?.hash===""?'text-[#972E4C] ':'text-[#52555D]'} `} >Logout</p>
                                    </button>
                                </>}
                            </li>
                        </ul>
                    </div>
                </div>
                :
                <div className='fixed top-0 left-0 min-w-[30px] w-[30px] shadow-s2 h-screen rounded-tr-[12px] rounded-br-[12px] border-r border-[#0000001A] relative z-[99] bg-[#fff] closed_sidebar'>
                    {/* onMouseEnter={()=>setIsSideBar(true)} onMouseLeave={()=>setIsSideBar(false)}  */}
                    <button id="menu" disabled={restrict} onClick={handleClickSideNavBar} className='p-1.5 border border-[#F6F6F6] rounded-lg shadow-s2 pl-1 absolute top-5 right-[-12px] bg-white' >
                        <img loading='lazy' decoding='async' src="/images/menu_slider.svg" alt="menu-icon"/>
                    </button>
                </div>
            }
            
            {logOutOpen && 
            <AnimatedModel key="logout-model"
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleLogout}
                        handleClose={() => setLogOutOpen(false)}
                        tittle= {`Logout`}
                        message = {`Are you sure you want to logout?`}
                        buttonName = {`Logout`}
                        disabled={logoutLoading}
                        loadingActivation={logoutLoading}
                    />
                }
            />  
            }
        </AnimatePresence>
    );
}
const memoisedComponent=React.memo(SideNavBar)
export default memoisedComponent
